import { Button, Flex, List, Typography } from "antd";
import Valor from "../../../../../../../Models/Financeiro/Faturamento/Imposto/Configuracao/Valor";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import Utilitario from "../../../../../../../Utils/Utilitario";

interface IValorListProps {
    valores:Valor[],
    remove:(valor:Valor) => void;
}
export default function ValorListBasic({
    valores,
    remove
}:IValorListProps) {
    return <List 
        bordered
        dataSource={valores}
        renderItem={(item, index) => renderValorList(item, index, remove)}
    />
}
function renderValorList(item:Valor, index:number, remove:(valor:Valor) => void) {
    const text = `${item.valor} com vigência em ${Utilitario.dateToString(item.dataInicial, 'dd/MM/yyyy')}`;
    function onClickRemove() {
        remove(item);
    }
    return <List.Item>
        <Typography.Text style={{ alignSelf : "center" }}>{text}</Typography.Text>
        <Button type="primary" shape="circle" danger onClick={onClickRemove} icon={<CloseOutlined />} />
    </List.Item>;
}